/**
 * Normalizes text extracted from PDFs that may have broken spacing.
 * Handles cases where pdf.js extracts characters individually, producing
 * text like "T r a n s a c t i o n" instead of "Transaction".
 * Also strips null bytes and normalizes whitespace.
 */
function normalizeExtractedText(text) {
    // 1. Strip ALL control characters and invisible Unicode
    text = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');  // ASCII control chars
    text = text.replace(/[\u200B\u200C\u200D\uFEFF]/g, '');          // zero-width chars
    text = text.replace(/\u00A0/g, ' ');                              // NBSP → regular space

    // 2. Collapse single-character-with-spaces patterns.
    //    Matches sequences of: (letter/digit)(space)(letter/digit)(space)... repeated 3+ times
    //    e.g. "T r a n s a c t i o n" → "Transaction"
    //    But does NOT collapse intentional short words like "I am a"
    text = text.replace(/\b([\w₹])\s(?=[\w₹]\s[\w₹])/g, function () {
        // We'll use a more targeted approach: find runs of spaced single chars
        return arguments[1];
    });

    // More aggressive: find and fix runs of 3+ single chars separated by single spaces
    text = text.replace(/(^|[^a-zA-Z0-9])([a-zA-Z0-9])((?:\s[a-zA-Z0-9]){2,})(?=[^a-zA-Z0-9]|$)/g, function (match, prefix, first, rest) {
        const collapsed = first + rest.replace(/\s/g, '');
        return prefix + collapsed;
    });

    // 3. Normalize multiple spaces into single space
    text = text.replace(/\s{2,}/g, '  ');

    return text.trim();
}

export function parsePhonePeText(text) {
    // Normalize the extracted text to handle broken spacing from pdf.js
    text = normalizeExtractedText(text);

    console.log(text + "\n\n")

    // Flexible header matching — handles any spacing variation
    var headerRegex = /Date\s+Transaction\s+Details\s+Type\s+Amount/i;
    var headerMatch = text.match(headerRegex);
    if (!headerMatch) return [];

    var idx = text.indexOf(headerMatch[0]);
    var data = text.slice(idx + headerMatch[0].length).trim();

    var dateRegex = new RegExp(
        "(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\s+\\d{1,2},\\s+\\d{4}" +
        "\\s+" +                     // spaces between date and time
        "\\d{1,2}[: ]?\\d{2}" +      // colon, space, or NO separator between HH and MM
        "\\s+(am|pm)",               // space before am/pm
        "gi"
    );

    var matches = [];
    var match;
    while ((match = dateRegex.exec(data)) !== null) {
        matches.push({ text: match[0], index: match.index });
    }

    var txns = [];
    for (var i = 0; i < matches.length; i++) {
        var m = matches[i];
        var dateTime = m.text;
        var start = m.index + dateTime.length;
        var end = i < matches.length - 1 ? matches[i + 1].index : data.length;
        var chunk = data.slice(start, end).trim();

        var type = "";
        if (chunk.indexOf("DEBIT") !== -1) type = "DEBIT";
        else if (chunk.indexOf("CREDIT") !== -1) type = "CREDIT";

        var amountMatch = chunk.match(/₹[\d,]+/);
        var amount = amountMatch ? amountMatch[0] : "";

        var party = "";
        var paidToIdx = chunk.indexOf("Paid to");
        var recvFromIdx = chunk.indexOf("Received from");
        var payToIdx = chunk.indexOf("Payment to");

        if (paidToIdx !== -1) {
            var tempStr = chunk.slice(paidToIdx + 8);
            var txnIdx = tempStr.indexOf("Transaction");
            if (txnIdx !== -1) party = tempStr.slice(0, txnIdx).trim();
        } else if (recvFromIdx !== -1) {
            var tempStr2 = chunk.slice(recvFromIdx + 14);
            var txnIdx2 = tempStr2.indexOf("Transaction");
            if (txnIdx2 !== -1) party = tempStr2.slice(0, txnIdx2).trim();
        } else if (payToIdx !== -1) {
            var tempStr3 = chunk.slice(payToIdx + 11);
            var txnIdx3 = tempStr3.indexOf("Transaction");
            if (txnIdx3 !== -1) party = tempStr3.slice(0, txnIdx3).trim();
        }

        var transactionId = "";
        var txnIdIdx = chunk.indexOf("Transaction ID");
        if (txnIdIdx !== -1) {
            var tempStr4 = chunk.slice(txnIdIdx + 15).trim();
            var spaceIdx = tempStr4.indexOf(" ");
            transactionId = spaceIdx !== -1 ? tempStr4.slice(0, spaceIdx) : tempStr4;
        }

        var utrNo = "";
        var utrIdx = chunk.indexOf("UTR No");
        if (utrIdx !== -1) {
            var tempStr5 = chunk.slice(utrIdx + 8).trim();
            var spaceIdx2 = tempStr5.indexOf(" ");
            utrNo = spaceIdx2 !== -1 ? tempStr5.slice(0, spaceIdx2) : tempStr5;
        }

        var account = "";
        var paidByIdx = chunk.indexOf("Paid by");
        var creditedToIdx = chunk.indexOf("Credited to");
        if (paidByIdx !== -1) {
            account = chunk.slice(paidByIdx + 8).trim().split(/\s+/).slice(0, 3).join(" ");
        } else if (creditedToIdx !== -1) {
            account = chunk.slice(creditedToIdx + 12).trim().split(/\s+/).slice(0, 3).join(" ");
        }

        if (dateTime && type && amount) {
            txns.push({
                date_time: dateTime,
                type: type,
                amount: amount,
                party: party,
                transaction_id: transactionId,
                utr_no: utrNo,
                account: account,
                tag: ""
            });
        }
    }

    return txns;
}

export function parseGPayText(text) {
    text = normalizeExtractedText(text);

    var headerRegex = /Date\s+&\s+time\s+Transaction\s+details\s+Amount/i;
    var headerMatch = text.match(headerRegex);
    var idx, data;
    if (headerMatch) {
        idx = text.indexOf(headerMatch[0]);
        data = text.slice(idx + headerMatch[0].length).trim();
    } else {
        // Fallback to exact match
        var header = "Date & time   Transaction details   Amount";
        idx = text.indexOf(header);
        if (idx === -1) return [];
        data = text.slice(idx + header.length).trim();
    }
    var dateRegex = new RegExp("\\d{2}\\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec),\\s+\\d{4}\\s+\\d{1,2}:\\d{2}\\s+(AM|PM)", "gi");
    var matches = [];
    var match;
    while ((match = dateRegex.exec(data)) !== null) {
        matches.push({ text: match[0], index: match.index });
    }

    var txns = [];
    for (var i = 0; i < matches.length; i++) {
        var m = matches[i];
        var dateTime = m.text;
        var start = m.index + dateTime.length;
        var end = i < matches.length - 1 ? matches[i + 1].index : data.length;
        var chunk = data.slice(start, end).trim();

        var type = "";
        var party = "";

        var chunkLower = chunk.toLowerCase();
        var paidToIdx = chunkLower.indexOf("paid to");
        var recvFromIdx = chunkLower.indexOf("received from");

        if (recvFromIdx !== -1 && (paidToIdx === -1 || recvFromIdx < paidToIdx)) {
            type = "CREDIT";
            var tempStr = chunk.slice(recvFromIdx + 14);
            var upiIdx = tempStr.toUpperCase().indexOf("UPI");
            if (upiIdx !== -1) party = tempStr.slice(0, upiIdx).trim();
        } else if (paidToIdx !== -1) {
            type = "DEBIT";
            var tempStr2 = chunk.slice(paidToIdx + 8);
            var upiIdx2 = tempStr2.toUpperCase().indexOf("UPI");
            if (upiIdx2 !== -1) party = tempStr2.slice(0, upiIdx2).trim();
        }

        var amountMatch = chunk.match(/₹[\d,]+(?:\.\d{2})?/);
        var amount = amountMatch ? amountMatch[0] : "";

        var transactionId = "";
        var txnIdIdx = chunk.indexOf("UPI Transaction ID:");
        if (txnIdIdx !== -1) {
            var tempStr3 = chunk.slice(txnIdIdx + 20).trim();
            var spaceIdx = tempStr3.indexOf(" ");
            transactionId = spaceIdx !== -1 ? tempStr3.slice(0, spaceIdx) : tempStr3;
        }

        var account = "";
        var paidByIdx = chunkLower.indexOf("paid by");
        var receivedInIdx = chunkLower.indexOf("received in");

        if (paidByIdx !== -1) {
            var tempStr4 = chunk.slice(paidByIdx + 8);
            var rupeeIdx = tempStr4.indexOf("₹");
            account = rupeeIdx !== -1 ? tempStr4.slice(0, rupeeIdx).trim() : tempStr4.trim();
        } else if (paidToIdx !== -1) {
            var tempStr5 = chunk.slice(paidToIdx + 8);
            var rupeeIdx2 = tempStr5.indexOf("₹");
            account = rupeeIdx2 !== -1 ? tempStr5.slice(0, rupeeIdx2).trim() : tempStr5.trim();
        } else if (receivedInIdx !== -1) {
            var tempStr6 = chunk.slice(receivedInIdx + 12);
            var rupeeIdx3 = tempStr6.indexOf("₹");
            account = rupeeIdx3 !== -1 ? tempStr6.slice(0, rupeeIdx3).trim() : tempStr6.trim();
        }

        if (dateTime && type && amount) {
            txns.push({
                date_time: dateTime,
                type: type,
                amount: amount,
                party: party,
                transaction_id: transactionId,
                utr_no: "",
                account: account,
                tag: ""
            });
        }
    }

    return txns;
}

export function parsePaytmText(text) {
    text = normalizeExtractedText(text);

    var headerVariants = [
        "Date & Time Transaction Details",
        "Date & Time   Transaction Details",
        "Payments History"
    ];

    var idx = -1;
    for (var h = 0; h < headerVariants.length; h++) {
        idx = text.indexOf(headerVariants[h]);
        if (idx !== -1) break;
    }

    if (idx === -1) return [];

    var data = text.slice(idx + 200).trim();

    var dateRegex = new RegExp("(\\d{2})\\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\s+(\\d{1,2}):(\\d{2})\\s+(AM|PM)", "gi");
    var matches = [];
    var match;
    while ((match = dateRegex.exec(data)) !== null) {
        matches.push({ text: match[0], index: match.index });
    }

    var txns = [];
    for (var i = 0; i < matches.length; i++) {
        var m = matches[i];
        var dateTime = m.text;
        var start = m.index + dateTime.length;
        var end = i < matches.length - 1 ? matches[i + 1].index : data.length;
        var chunk = data.slice(start, end).trim();

        var type = "";
        var party = "";

        var paidToIdx = chunk.indexOf("Paid to");
        var receivedFromIdx = chunk.indexOf("Received from");

        if (receivedFromIdx !== -1 && (paidToIdx === -1 || receivedFromIdx < paidToIdx)) {
            type = "CREDIT";
            var tempStr = chunk.slice(receivedFromIdx + 14);
            var upiIdx = tempStr.indexOf("UPI ID:");
            if (upiIdx !== -1) {
                party = tempStr.slice(0, upiIdx).trim();
            } else {
                var noteIdx = tempStr.indexOf("Note:");
                if (noteIdx !== -1) party = tempStr.slice(0, noteIdx).trim();
                else {
                    var tagIdx = tempStr.indexOf("Tag:");
                    if (tagIdx !== -1) party = tempStr.slice(0, tagIdx).trim();
                }
            }
        } else if (paidToIdx !== -1) {
            type = "DEBIT";
            var tempStr2 = chunk.slice(paidToIdx + 8);
            var upiIdx2 = tempStr2.indexOf("UPI ID:");
            if (upiIdx2 !== -1) {
                party = tempStr2.slice(0, upiIdx2).trim();
            } else {
                var noteIdx2 = tempStr2.indexOf("Note:");
                if (noteIdx2 !== -1) party = tempStr2.slice(0, noteIdx2).trim();
                else {
                    var tagIdx2 = tempStr2.indexOf("Tag:");
                    if (tagIdx2 !== -1) party = tempStr2.slice(0, tagIdx2).trim();
                }
            }
        }

        var tag = "";
        var tagMatch = chunk.match(/Tag:\s*#\s*([A-Za-z\s]+)/);
        if (tagMatch && tagMatch[1]) {
            tag = tagMatch[1].trim().split(/\s+/)[0];
        }

        var account = "";
        var accountMatch = chunk.match(/([A-Za-z]+\s+Bank\s+-\s+\d{2})/);
        if (accountMatch) {
            account = accountMatch[0];
        }

        var amount = "";
        var amountPatterns = [
            /-\s*Rs\.([\d,]+)/,
            /\+\s*Rs\.([\d,]+)/,
            /Rs\.([\d,]+)/
        ];

        for (var ap = 0; ap < amountPatterns.length; ap++) {
            var amtMatch = chunk.match(amountPatterns[ap]);
            if (amtMatch) {
                amount = "₹" + amtMatch[1];
                break;
            }
        }

        var transactionId = "";
        var upiRefMatch = chunk.match(/UPI Ref No:\s*(\d+)/);
        if (upiRefMatch) {
            transactionId = upiRefMatch[1];
        }

        if (dateTime && type && amount) {
            txns.push({
                date_time: dateTime,
                type: type,
                amount: amount,
                party: party,
                transaction_id: transactionId,
                utr_no: "",
                account: account,
                tag: tag
            });
        }
    }

    return txns;
}

export function parseAmount(str) {
    var cleaned = String(str).replace(/₹/g, "").replace(/,/g, "").replace(/Rs\./g, "");
    return parseFloat(cleaned) || 0;
}

export function parseAmountAbs(txn) {
    let amt = txn.amount;
    if (typeof amt === 'number') return Math.abs(amt);
    if (typeof amt === 'string') {
        // Remove currency symbols, commas, and literal 'Rs'/'Rs.'
        amt = amt.replace(/Rs\.?|₹/g, '').replace(/[,\s]/g, '');
        // Then remove any other non-numeric chars except digits and decimals
        amt = amt.replace(/[^0-9.-]/g, '');
    }
    const parsed = parseFloat(amt);
    return isNaN(parsed) ? 0 : Math.abs(parsed);
}

/**
 * Parse statement date strings into a local calendar Date at 00:00:00.
 * Supports PhonePe ("Jan 5, 2026 …"), GPay ("05 Jan, 2026 …"), Paytm ("05 Jan 10:30 AM" — no year).
 */
export function parseDateOnly(dateTimeStr, now = new Date()) {
    if (!dateTimeStr || typeof dateTimeStr !== 'string') return null;

    const months = {
        jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
        jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
    };

    const makeDay = (year, monthIndex, day) => {
        if (!Number.isFinite(year) || !Number.isFinite(monthIndex) || !Number.isFinite(day)) return null;
        if (monthIndex < 0 || monthIndex > 11 || day < 1 || day > 31) return null;
        const d = new Date(year, monthIndex, day);
        if (Number.isNaN(d.getTime())) return null;
        // Reject overflow (e.g. Feb 31 → Mar 3)
        if (d.getFullYear() !== year || d.getMonth() !== monthIndex || d.getDate() !== day) return null;
        d.setHours(0, 0, 0, 0);
        return d;
    };

    const resolveYearless = (monthIndex, day) => {
        const y = now.getFullYear();
        let d = makeDay(y, monthIndex, day);
        if (!d) return null;
        // If date would be far in the future (e.g. Dec when now is Jan), it's last year
        const tomorrow = new Date(now);
        tomorrow.setHours(0, 0, 0, 0);
        tomorrow.setDate(tomorrow.getDate() + 1);
        if (d > tomorrow) {
            d = makeDay(y - 1, monthIndex, day);
        }
        return d;
    };

    // PhonePe: "Jan 5, 2026" / "Jan 05, 2026"
    let m = dateTimeStr.match(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+(\d{1,2}),\s+(\d{4})\b/i);
    if (m) {
        return makeDay(parseInt(m[3], 10), months[m[1].slice(0, 3).toLowerCase()], parseInt(m[2], 10));
    }

    // GPay: "05 Jan, 2026" / "5 Jan, 2026"
    m = dateTimeStr.match(/\b(\d{1,2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*,\s+(\d{4})\b/i);
    if (m) {
        return makeDay(parseInt(m[3], 10), months[m[2].slice(0, 3).toLowerCase()], parseInt(m[1], 10));
    }

    // Paytm (often no year): "05 Jan 10:30 AM" / "5 Jan 10:30 AM"
    m = dateTimeStr.match(/\b(\d{1,2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\b/i);
    if (m) {
        return resolveYearless(months[m[2].slice(0, 3).toLowerCase()], parseInt(m[1], 10));
    }

    // Yearless month-first: "Jan 5 10:30 am"
    m = dateTimeStr.match(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+(\d{1,2})\b/i);
    if (m) {
        return resolveYearless(months[m[1].slice(0, 3).toLowerCase()], parseInt(m[2], 10));
    }

    // ISO-ish: 2026-07-15 or 2026/07/15
    m = dateTimeStr.match(/\b(\d{4})[-/](\d{1,2})[-/](\d{1,2})\b/);
    if (m) {
        return makeDay(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
    }

    // Numeric Indian: 15/07/2026 or 15-07-2026
    m = dateTimeStr.match(/\b(\d{1,2})[-/](\d{1,2})[-/](\d{4})\b/);
    if (m) {
        return makeDay(parseInt(m[3], 10), parseInt(m[2], 10) - 1, parseInt(m[1], 10));
    }

    return null;
}

/** Start of local day that is `days` before today (inclusive window for Free history). */
export function getFreeHistoryCutoff(days = 30, now = new Date()) {
    const cutoff = new Date(now);
    cutoff.setHours(0, 0, 0, 0);
    cutoff.setDate(cutoff.getDate() - days);
    return cutoff;
}


export function formatDateGroup(dateStr) {
    if (!dateStr) return '';
    var parts = dateStr.match(/(\d{1,2})\s*(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s*'?(\d{2,4})?/i);
    if (parts) {
        var day = parts[1];
        var month = parts[2].substring(0, 3);
        var year = parts[3] ? ("'" + parts[3].slice(-2)) : '';
        return day + ' ' + month + ' ' + year;
    }
    return dateStr.split(' ')[0] || dateStr;
}

export function formatTimeOnly(dateStr) {
    if (!dateStr) return '';
    var timeParts = dateStr.match(/(\d{1,2}:\d{2}(?::\d{2})?\s*(?:AM|PM)?)/i);
    return timeParts ? timeParts[1] : '';
}
